<template>
    <section class="container" v-if="events">
        <div class="row mt-5">
            <div class="col-12"><h1>Past 14 days Incidents</h1></div>
        </div>
        <section v-for="event in events">
            <div class="row mt-3">
                <div class="col-12">
                    <h6>{{ dateFormat(event.date) }}</h6>
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-12 t-small">
                    <p v-if="!event.incidents">No incidents reported today.</p>
                    <section v-if="event.incidents" v-for="incident in event.incidents" class="incident mt-2">
                        <div class="row mb-2">
                            <div class="col-12 monitor-name">{{ getMonitorName(incident.entityGuid) }}</div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 outage">
                                <div class="row">
                                    <div class="col-8">
                                        <i :class="incident.priority" class="fas fa-exclamation-triangle"></i>
                                        {{ outageMessage(incident.priority) }}
                                        <span class="time">@{{ timeFormat(incident.openTime) }}</span>
                                    </div>
                                    <div class="col-4 text-right">
                                        {{ duration(incident.durationSeconds).minutes }} min
                                        {{ duration(incident.durationSeconds).seconds }} sec
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
                                        <span
                                            class="tag"
                                            v-for="(center, index) in incident.dataCenter"
                                            :title="incident.locations[index]"
                                            >{{ convertCenterName(center) }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import ApiRequest from '../../utilities/apiRequest'
import { useStore } from 'vuex'
import dayjs from 'dayjs'

// lodash components
import find from 'lodash/find'
import map from 'lodash/map'
import upperFirst from 'lodash/upperFirst'
import slice from 'lodash/slice'
import split from 'lodash/split'

export default {
    props: ['monitors'],
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    data() {
        return {
            events: false,
            loaded: false,
        }
    },
    mounted: function () {
        this.getMonitorEvents()
    },
    prevMonitor: false,
    methods: {
        getMonitorEvents: function () {
            ApiRequest.get(this.$store, this.url(`/api/v2/status/uptime/all/events`), {
                monitors: map(this.monitors, monitor => monitor.entityGuid),
            }).then(data => {
                this.events = data
                this.loaded = true
            })
        },
        dateFormat: function (date) {
            return dayjs(date).format('MMM DD, YYYY')
        },
        timeFormat: function (date) {
            return dayjs(date).format('HH:mm:ss')
        },
        duration: function (duration) {
            const minutes = Math.floor(duration / 60)
            const seconds = Math.floor(duration - minutes * 60)
            return {
                minutes: minutes,
                seconds: seconds,
            }
        },
        convertCenterName: function (dataCenter) {
            const splitName = split(dataCenter, '_')
            splitName[2] = upperFirst(splitName[2].toLowerCase())
            return slice(splitName, 1).join(' ')
        },
        outageMessage: function (priority) {
            return this.$t(`status.eventDetails.${priority}`)
        },
        getMonitorName: function (entityGuid) {
            let monitorName = ''
            if (this.$options.prevMonitor === false || this.$options.prevMonitor !== entityGuid) {
                this.$options.prevMonitor = entityGuid
                monitorName = find(this.monitors, monitor => monitor.entityGuid === entityGuid).monitorName
            }
            return monitorName
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';

.status-table-container {
    h1 {
        font-size: rem(24px);
        font-weight: 700;
    }
    .outage {
        padding: 10px;
        background: var(--white);
        border: 1px solid #e5e5e5;
        box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        margin-bottom: 8px;
    }

    .monitor-name {
        line-height: rem(17px);
        letter-spacing: 0.01em;
        font-weight: bold;
        text-align: left;
        color: var(--text-offer-example);

        @media screen and (max-width: $bp-medium) {
            font-size: 0.9rem;
        }
    }

    h6 {
        font-size: rem(18px);
        font-weight: 700;
    }

    .tag {
        background-color: var(--standard-tag-background-color);
        border-radius: 4px;
        color: var(--standard-tag-font-color);
        font-size: 0.6rem;
        font-weight: bold;
        padding: 4px 6px;
        white-space: nowrap;
        cursor: pointer;
        margin: 5px;
    }
}
</style>
